import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { Toast,allowMultipleToast ,Lazyload  } from 'vant';
import { createPinia } from 'pinia'
import piniaPersistedstate from 'pinia-plugin-persistedstate'
import { i18n } from '@/i18n';
import 'vant/es/toast/style'; 
import 'vant/es/dialog/style'; 
import 'vant/lib/index.css'
import './styles/global.scss'
// import AOS from 'aos'
// import 'aos/dist/aos.css'
function setRem() {
    const docEl = document.documentElement
    const clientWidth = window.innerWidth || docEl.clientWidth
    if (!clientWidth) return
    const maxWidth = 390 // 限制最大宽度，避免超宽屏放大过头
    const baseSize = 37.5 // 设计稿宽度/20

    const effectiveWidth = clientWidth > maxWidth ? maxWidth : clientWidth
    docEl.style.fontSize = (effectiveWidth / 375) * baseSize + 'px'
}
window.addEventListener('resize', setRem) 
setRem()

// AOS.init({
//   easing:"ease",
//   duration: 800,
//   once: true,       // 只执行一次（推荐）
//   offset: 10
// })
// 全局设置
// allowMultipleToast(true) //允许多个loading

const app = createApp(App)
app.use(Toast);
app.use(Lazyload);
app.use(Lazyload, {
  lazyComponent: true,
});
const pinia = createPinia()
pinia.use(piniaPersistedstate) // 注册插件
app.use(pinia)
app.use(router)
// 国际化
app.use(i18n);

app.mount('#app')
